export default __webpack_public_path__ + "static/assets/med_pill_elipse_in_L0_solid_x_01_f.e736921e.png";